module.exports = __webpack_public_path__ + "img/10.2fe5368f.png";